import gql from 'graphql-tag';

const MARKET_SETUP_FRAGMENT = gql`
	fragment marketSetup on MarketSetup {
		id
		identifier
		assignees {
			id
			firstname
			lastname
			username
		}
		commDevices {
			id
			deviceId
			secondaryId
			setupInformation
			lastCommunication
		}
		machine {
			id
			assetId
			type
			destroyed
			location {
				id
				name
				destroyed
			}
			place {
				id
				name
			}

		}
		plannedMachine {
			id
			assetId
			type
			destroyed
			location {
				id
				name
				destroyed
				isWarehouse
			}
			place {
				id
				name
			}
		}
		movePlanId
		moveSourceLocation {
			id
			name
			isWarehouse
		}
		moveSourcePlace {
			id
			name
		}
		movePlannedAt
		movePlannedBy {
			id
			firstname
			lastname
		}
		moveConfirmedAt
		moveConfirmedBy {
			id
			firstname
			lastname
		}
		route {
			id
			name
		}
		locationSetup {
			id
			dueDate
			identifier
			location {
				id
				name
				destroyed
				client {
					id
					name
				}
			}
		}
		place {
			id
			name
			destroyed
		}
		planogram {
			id
			name
		}
		placePhotos {
			id
			link
			comment
			created
		}
		finalPhotos {
			id
			link
			comment
			created
		}
		status
		created
		creator {
			id
			firstname
			lastname
			username
		}
		additionalInstructions
		stickyNote
		paymentDevicesSerialNo
		assignKiosk
		testNayaxTransaction
		phoneTransactionTest
		verifySalesTransactionInSentry
		liftDimensions
		availableWidth
		availableHeight
		availableDepth
		imageUrl	
		setUpSentryPlanogram
		clientCurrentVendingSetup
		internetConnectivity
		routerModel
		simNumber
		marketType
		marketFinish
		customFinish
		marketBays
		informClientOfRelevantInformation
		sendEmail
		testAndTagElectricalEquipment
		purchaseOrAllocateFridges
		setUpRequiredFridges
		purchaseOrAllocateGondolaShelving
		confirmConfiguration
		bookRemovalOfVendingMachines
		organiseEmptyingOfVendingMachine
		purchaseOrAllocateModem
		testInternetConnectivity
		organiseInstallationOfMM
		marketBrand
		foodOptions
		initialCampaigns {
			id
			name
		}
		agoraWalletTicketCreated
		posSignageTicketCreated
		directionsTicketCreated
		temperatureTestTicketCreated
		fridgeSerialNumberTicketCreated
		welcomePromotionFollowUpPendingReason
		welcomePromotionFollowUpSentAt
	}
`;

export const CREATE_MARKET_SETUP = gql`
    mutation createMarketSetupMutation($input: CreateMarketSetupInput!) {
        createMarketSetup(input: $input) {
            ...marketSetup
        }
	}
	${MARKET_SETUP_FRAGMENT}
`;

export const GET_MARKET_SETUPS = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: MarketSetupPageFilter
	) {
		getMarketSetups(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...marketSetup
			}
			count
		}
	}
	${MARKET_SETUP_FRAGMENT}
`;

export const GET_MARKET_SETUPS_COUNT = gql`
	query {
		countMarketSetups
	}
`;

export const DESTROY_MARKET_SETUP = gql`
	mutation destroyMarketSetupMutation ($id: ID!) {
		destroyMarketSetup(id: $id)
	}
`;


export const GET_MARKET_SETUP = gql`
	query($id: String) {
		getMarketSetup(id: $id) {
			...marketSetup
		}
	}
	${MARKET_SETUP_FRAGMENT}
`;

export const MODIFY_MARKET_SETUP = gql`
	mutation modifyMarketSetupMutation($input: ModifyMarketSetupInput!) {
		modifyMarketSetup(input: $input) {
			marketsetup {
				...marketSetup
			}
		}
	}
	${MARKET_SETUP_FRAGMENT}
`;

export const PLAN_MARKET_SETUP_MOVE = gql`
	mutation planMarketSetupMoveMutation($setupId: ID!, $machineId: ID!) {
		planMarketSetupMove(setupId: $setupId, machineId: $machineId) {
			...marketSetup
		}
	}
	${MARKET_SETUP_FRAGMENT}
`;

export const CONFIRM_MARKET_SETUP_MOVE = gql`
	mutation confirmMarketSetupMoveMutation($setupId: ID!, $movePlanId: ID!) {
		confirmMarketSetupMove(setupId: $setupId, movePlanId: $movePlanId) {
			...marketSetup
		}
	}
	${MARKET_SETUP_FRAGMENT}
`;

export const CANCEL_MARKET_SETUP_MOVE = gql`
	mutation cancelMarketSetupMoveMutation($setupId: ID!, $movePlanId: ID!) {
		cancelMarketSetupMove(setupId: $setupId, movePlanId: $movePlanId) {
			...marketSetup
		}
	}
	${MARKET_SETUP_FRAGMENT}
`;
